import { ApiClientError } from '~/ApiClient';
import Price from '~/utils/Price';

import FinalCalculation from './FinalCalculation';
import mapComparativePrice, { RawComparativePrice } from './mapComparativePrice';
import { mapError } from './mapError';
import mapReferencedProduct, { RawReferencedProduct } from './mapReferencedProduct';

export interface RawFinalCalculation {
	comparativePrice: RawComparativePrice | null;
	percentsOfComparativePrice: number;
	maximumPepValue: Price | null;
	maximumWholesalePrice: Price | null;
	referencedProduct: RawReferencedProduct | null;
	potentialPriceDropPercents: number;
	emptyResultReason: {
		code: string;
		meta: { product?: { id: string } } | null;
	}[];
}

export default function mapFinalCalculation(finalCalculation: RawFinalCalculation): FinalCalculation {
	return new FinalCalculation(
		finalCalculation.comparativePrice !== null ? mapComparativePrice(finalCalculation.comparativePrice) : null,
		finalCalculation.percentsOfComparativePrice,
		finalCalculation.maximumPepValue !== null
			? new Price(finalCalculation.maximumPepValue.value, finalCalculation.maximumPepValue.currency)
			: null,
		finalCalculation.maximumWholesalePrice !== null
			? new Price(finalCalculation.maximumWholesalePrice.value, finalCalculation.maximumWholesalePrice.currency)
			: null,
		finalCalculation.referencedProduct !== null ? mapReferencedProduct(finalCalculation.referencedProduct) : null,
		finalCalculation.potentialPriceDropPercents,
		finalCalculation.emptyResultReason.map(({ code, meta }) =>
			mapError(new ApiClientError(code, code, null, null, meta || {}))
		)
	);
}
